export function PrintSuccesMsg(text: string) {
  return (
    <>
      <strong>Successo!</strong> {text}
    </>
  )
}
